<template>
    <component
        :is="showDisplay"
        :product="summary"
        v-bind="props"
        :availability="computedAvailability"
        :pricing="computedPricing"
        :is-loading-meta="isLoadingMeta"
    />
    <Meta
        :title="'Catalog | Products | ' + summary.sku?.toUpperCase()"
        :ogTitle="
            summary.vendor?.display_name + ' ' + summary.sku?.toUpperCase()
        "
        :json-ld-breadcrumbs="crumbs"
        :og-image="productImage"
        og-image-source="assets"
        :og-image-pad-transform="true"
        :description="
            _.get(summary, 'descriptions.product-description.0.short', '')
        "
    />
    <ProductSchema
        :product="summary"
        :product-image="productImage"
        :vendor-logo="vendorLogo"
    />
</template>
<script setup>
import { computed, markRaw, nextTick, onMounted, ref } from "vue";
import { useSegment, useUser } from "@/Composables";
import { Meta, ProductSchema } from "@/Components";
import MarketingShow from "../../../Themes/Marketing/Pages/Catalog/Products/Show.vue";
import SourcingShow from "../../../Themes/Sourcing/Pages/Catalog/Products/Show.vue";
import { router } from "@inertiajs/vue3";
import _ from "lodash";

const { settings } = useUser();
const props = defineProps([
    "flash",
    "crumbs",
    "summary",
    "referer",
    "customer",
    "surcharge",
    "card",
    "options",
    "resources",
    "components",
    "companions",
    "substitutes",
    "inventory",
    "performance",
    "finish_swatch",
    "master_note_restriction",
    "builder",
]);

const showDisplay = computed(() =>
    settings.value.is_sourcing_mode
        ? markRaw(SourcingShow)
        : markRaw(MarketingShow)
);

const productImage = computed(() => {
    return props.summary?.assets?.["product-image"]?.[0]?.external_id ?? null;
});

const vendorLogo = computed(() => {
    return props.summary?.vendor?.logo?.external_id ?? null;
});

const track = (meta) => {
    useSegment().track.productViewed({
        card: props.card,
        pricing: computedPricing.value,
        availability: computedAvailability.value,
    });
};

const isLoadingMeta = ref(true);
const computedPricing = ref(false);
const computedAvailability = ref(false);

onMounted(() => {
    router.reload({
        only: [
            "flash",
            "pricing",
            "availability",
            "options",
            "resources",
            "components",
            "companions",
            "substitutes",
            "finish_swatch",
            "master_note_restriction",
            "builder",
            ...(useUser().isEmployee() ? ["inventory", "order_history"] : []),
            ...(useUser().isEmployee() && settings.value.is_sourcing_mode
                ? ["performance"]
                : []),
        ],
        preserveScroll: true,
        onBefore: () => {
            isLoadingMeta.value = true;
        },
        onSuccess: (response) => {
            computedPricing.value = response.props.pricing;
            computedAvailability.value = response.props.availability;
            nextTick(() => (isLoadingMeta.value = false));
            track();
        },
        onError: () => {
            nextTick(() => (isLoadingMeta.value = false));
        },
        onFinish: () => {
            //nextTick(() => isLoadingMeta.value = false); //This is causing a racing condition. Move to onError and onSuccess instead.
        },
    });
});
</script>
